var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7706 5.87834C41.1381 5.24467 40.1117 5.24358 39.4791 5.87565L20.0373 25.2661L13.0228 17.6477C12.4167 16.9897 11.3919 16.9471 10.7329 17.5531C10.0743 18.1592 10.0322 19.1845 10.6383 19.843L18.7954 28.7018C19.0941 29.0264 19.5122 29.215 19.953 29.2241C19.9648 29.2246 19.9763 29.2246 19.9876 29.2246C20.416 29.2246 20.8281 29.0545 21.1317 28.752L41.7674 8.17035C42.4016 7.53837 42.4027 6.512 41.7706 5.87834Z",
    fill: "#7FB722",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3794 19.8794C40.4842 19.8794 39.7588 20.6048 39.7588 21.5C39.7588 31.5683 31.5683 39.7588 21.5 39.7588C11.4323 39.7588 3.24121 31.5683 3.24121 21.5C3.24121 11.4323 11.4323 3.24121 21.5 3.24121C22.3951 3.24121 23.1206 2.51575 23.1206 1.62065C23.1206 0.725457 22.3951 0 21.5 0C9.64477 0 0 9.64477 0 21.5C0 33.3547 9.64477 43 21.5 43C33.3547 43 43 33.3547 43 21.5C43 20.6049 42.2745 19.8794 41.3794 19.8794Z",
    fill: "#7FB722",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCheckmark);
export default __webpack_public_path__ + "static/media/toast_checkmark.f5ad3adcf419121bab80601dd6ccb879.svg";
export { ForwardRef as ReactComponent };